'use client';

import dynamic from 'next/dynamic';
import { useApartmentReviewsContext } from './ApartmentReviewsProvider';
import { ReviewsShell, type ReviewSourceConfig } from './ReviewsShell';
import { ReviewsEntryPoint } from './ReviewsEntryPoint';

const RedditReviewsPanel = dynamic(() => import('./RedditReviewsPanel'));
const GoogleReviewsPanel = dynamic(() => import('./GoogleReviewsPanel'));
const ReputationApiPanel = dynamic(() => import('./ReputationApiPanel'));
export function ApartmentReviewsModule() {
  const { lotId, reviews, googlePlaceId, redditTopics } = useApartmentReviewsContext();
  if (!reviews && !googlePlaceId && !redditTopics.length) return null;
  const sources: Array<ReviewSourceConfig> = [];
  const reputation = reviews?.reputation;
  if (reputation)
    sources.push({
      id: 'web',
      label: 'Web reviews',
      panel: { status: 'ready', render: () => <ReputationApiPanel data={reputation} /> },
    });
  if (googlePlaceId)
    sources.push({
      id: 'google',
      label: 'Google',
      instanceKey: googlePlaceId,
      eager: true,
      panel: {
        status: 'ready',
        render: () => <GoogleReviewsPanel placeId={googlePlaceId} />,
      },
    });
  if (redditTopics.length)
    sources.push({
      id: 'reddit',
      label: 'Reddit',
      panel: { status: 'ready', render: () => <RedditReviewsPanel topics={redditTopics} /> },
    });
  return <ReviewsShell key={lotId} id="reviews" sources={sources} />;
}

export function ApartmentReviewsEntry() {
  const { reviews, googlePlaceId, redditTopics } = useApartmentReviewsContext();
  if (!reviews && !googlePlaceId && !redditTopics.length) return null;
  const { averageRating, totalReviews } = reviews?.reputation ?? {};
  return (
    <ReviewsEntryPoint
      targetId="reviews"
      hasReputation={!!reviews?.reputation}
      aggregateRating={
        averageRating !== undefined && totalReviews !== undefined
          ? { rating: averageRating, reviewCount: totalReviews }
          : null
      }
      hasGooglePlace={!!googlePlaceId}
      hasRedditLinks={redditTopics.length > 0}
    />
  );
}
